import "regenerator-runtime/runtime";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(showGlobalSearchSuggestions),
    _marked2 = /*#__PURE__*/regeneratorRuntime.mark(fetchGlobalSearchSuggestions);

/*
 Copyright (c) 2017 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.

 This software is the confidential and proprietary information of Wells Fargo
 bank. ('Confidential Information'). You shall not disclose such Confidential
 Information and shall use it only in accordance with the terms of the license
 agreement you entered into with WellsFargo.

 Author: Akhil Mara

 Description:
 */

/*_*/
import { put, call, select, throttle } from 'redux-saga/effects';
import getExternalJSON from '../../../network/get-external-json';
import logger from '../../../logger/logger';
import globals from '../../../globals/globals';
import { getGlobalSearchValue } from '../../selectors';
import * as actions from '../actions';

function showGlobalSearchSuggestions() {
  var globalSearchValue, url, params, _yield$call, results;

  return regeneratorRuntime.wrap(function showGlobalSearchSuggestions$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return select(getGlobalSearchValue);

        case 3:
          globalSearchValue = _context.sent;
          url = globals().searchSuggestUrl || '/globalSearchSuggestions';
          params = {
            q: globalSearchValue,
            site: globals().searchSite,
            client: 'www_frontend'
          };
          _context.next = 8;
          return call(getExternalJSON, {
            url: url,
            params: params
          });

        case 8:
          _yield$call = _context.sent;
          results = _yield$call.results;
          _context.next = 12;
          return put(actions.setGlobalSearchSuggestions(results));

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](0);
          logger.error('Unable to retrieve suggestions from WWW', _context.t0.FailureMessageBean);

        case 17:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[0, 14]]);
}

function fetchGlobalSearchSuggestions() {
  return regeneratorRuntime.wrap(function fetchGlobalSearchSuggestions$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return throttle(1000, actions.GLOBAL_SEARCH_FETCH_SUGGESTIONS, showGlobalSearchSuggestions);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}

export default fetchGlobalSearchSuggestions;